import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = { 
    labels: Array, 
    data: Array,
    config: Object
  }

  connect() {
    if (typeof Chart === 'undefined') {
      console.error("Chart.js is not available!")
      return
    }
    
    this.createChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  createChart() {
    const canvas = this.element
    const ctx = canvas.getContext("2d")
    
    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy()
    }

    const labels = this.labelsValue || []
    const data = this.dataValue || []
    const customConfig = this.configValue || {}
    

    // Default radar chart configuration
    let config = {
      type: 'radar',
      data: {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          r: {
            angleLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            },
            pointLabels: {
              font: {
                size: 12
              }
            },
            suggestedMin: 0,
            suggestedMax: 5,
            ticks: {
              stepSize: 1
            }
          }
        }
      }
    }

    // Merge custom config if provided
    if (Object.keys(customConfig).length > 0) {
      config = this.deepMerge(config, customConfig)
      // Convert string functions to actual functions
      config = this.convertStringFunctions(config)
    }

    try {
      this.chart = new Chart(ctx, config)
    } catch (error) {
      console.error("Error creating radar chart:", error)
      console.error("Radar chart config:", config)
    }
  }

  deepMerge(target, source) {
    const result = { ...target }
    
    for (const key in source) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        result[key] = this.deepMerge(result[key] || {}, source[key])
      } else if (Array.isArray(source[key])) {
        // For arrays, replace entirely (don't merge)
        result[key] = source[key]
      } else {
        result[key] = source[key]
      }
    }
    
    return result
  }

  convertStringFunctions(obj) {
    if (typeof obj === 'string' && obj.startsWith('function(')) {
      return new Function('return ' + obj)()
    }
    
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertStringFunctions(item))
    }
    
    if (typeof obj === 'object' && obj !== null) {
      const result = {}
      for (const key in obj) {
        result[key] = this.convertStringFunctions(obj[key])
      }
      return result
    }
    
    return obj
  }
}